import React, { useState } from 'react';

import { Spin, Table, message, Space } from 'antd';
import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

import Configurazione from '../../Configurazione';
import sessionManager, { eVariableType } from '../../SessionManager';
import { GetErrorMessage } from '../../Utility';
import api from '../../api';
import { str } from '../../translations/stringres';
import FiltriMagazzino from '../FiltriMagazzino';
import type { filtriFields } from '../FiltriMagazzino';
import HeaderBar from '../HeaderBar';

export default function LavorazioniCliente() {
    const [isRunning, setIsunning] = useState(false);
    const [data, setData] = useState<any>();

    async function fetch(e: filtriFields) {
        try {
            setIsunning(true);
            const dt = {
                idSocieta: Configurazione().idsocieta,
                dataInizio: e.dataInizio,
                dataFine: e.dataFine,
                fatturate: e.fatturate,
                idQualita: e.idQualita,
                codFinitura: e.codFinitura,
                numFattura: e.numFattura,
                numeroBlocco: e.numeroBlocco,
                numeroBloccoFornitore: e.numeroBloccoFornitore,
            };

            const res = await api.post('Magazzino/Lavorazioni', dt);

            if (res != null && res.data != null) setData(res.data);
        } catch (error) {
            message.error(GetErrorMessage(error));
        } finally {
            setIsunning(false);
        }
    }

    function onConfirmFiltri(e: filtriFields) {
        fetch(e);
    }

    const cols: ColumnsType<any> = [
        {
            title: str('data'),
            dataIndex: 'dataMovimento',
            width: 60,
            render: (text) => (
                <div>
                    {new Date(text).toLocaleString(localStorage.getItem('codLingua')?.toString(), {
                        dateStyle: 'short',
                    })}
                </div>
            ),
        },
        { title: str('lavorazione'), dataIndex: 'lavorazione' },
        { title: str('numeroBlocco'), dataIndex: 'numeroBlocco', width: 60 },
        { title: str('numeroBloccoCliente'), dataIndex: 'numeroBloccoFornitore', width: 125 },
        { title: str('qualita'), dataIndex: 'qualita', width: 250 },
        { title: str('finitura'), dataIndex: 'finitura', width: 250 },
        { title: str('qta'), dataIndex: 'qtaLavorazione', width: 80, align: 'right' },
        { title: str('um'), dataIndex: 'um', width: 50 },
        { title: str('pezziTagli'), dataIndex: 'pezziTagli', width: 80, align: 'right' },
        { title: str('numeroDocumento'), dataIndex: 'numeroDocumento', width: 30 },
        {
            title: str('dataDocumento'),
            dataIndex: 'dataDocumento',
            width: 30,
            render: (text) => (
                <div>
                    {text != null
                        ? new Date(text).toLocaleString(localStorage.getItem('codLingua')?.toString(), {
                              dateStyle: 'short',
                          })
                        : ''}
                </div>
            ),
        },
        { title: str('lastre'), dataIndex: 'lastre', width: 30 },
        { title: str('prezzounitario'), dataIndex: 'prezzoUnitario', width: 30, align: 'right' },
        { title: str('sconto'), dataIndex: 'sconto', width: 30, align: 'right' },
        { title: str('prezzoTotale'), dataIndex: 'prezzoTotale', width: 30, align: 'right' },
    ];

    const rowKeys = ['idSocieta', 'numeroMovimento', 'numeroMovimentoPr'];

    return (
        <div style={{ margin: '0px' }}>
            <HeaderBar descrizione="Lavorazioni" menuSelezionato="LavorazioniCliente"></HeaderBar>
            <Space className="App-body" direction="vertical">
                <FiltriMagazzino
                    numeroBloccoVisible={true}
                    numeroBloccoFornitoreVisible={true}
                    fatturazioneVisible={true}
                    finituraVisible={true}
                    periodoVisible={true}
                    qualitaVisible={true}
                    dataIni={dayjs().subtract(2, 'month')}
                    params={null}
                    contoTerzi={true}
                    onconfirm={(e: filtriFields) => onConfirmFiltri(e)}
                ></FiltriMagazzino>
                <hr></hr>
                <Spin spinning={isRunning} size="large">
                    <Table
                        size="large"
                        rowKey={(row) => rowKeys.map((key) => row[key]).join('-')}
                        columns={cols}
                        dataSource={data}
                        scroll={{ x: 'max-content' }}
                    ></Table>
                </Spin>
            </Space>
        </div>
    );
}
